"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "formatAnalyticsLabel", {
    enumerable: true,
    get: function() {
        return formatAnalyticsLabel;
    }
});
function formatAnalyticsLabel(contexts, maxWords = 3) {
    const slugify = (label)=>label.toLowerCase().replace(/[-,.]/g, '_') // Replace hyphens, commas, and periods with underscores
        .replace(/[^a-z0-9_ ]+/g, '') // Remove special characters except underscores
        .split(' ').slice(0, maxWords).join('_');
    return contexts.filter((context)=>!!context).map((context)=>slugify(context)).join('__');
}

//# sourceMappingURL=utils.js.map